import type { ResourceStat, ServerResources } from '@frontend/types/adminhub';

interface ResourceMetersProps {
  serverResources: ServerResources;
  fmtBytes: (bytes: number) => string;
  meterLevel: (pct: number) => string;
}

export default function ResourceMeters({ serverResources, fmtBytes, meterLevel }: ResourceMetersProps) {
  return (
    <>
      <div className="resource-meter-grid">
        {([
          ['CPU', serverResources.cpu],
          ['RAM', serverResources.ram],
          ['Disk', serverResources.disk]
        ] as [string, ResourceStat][]).map(([label, stat]) => (
          <div key={label} className="resource-meter-item">
            <div className="resource-meter-label">
              <strong>{label}</strong>
              <span>
                {label === 'CPU'
                  ? `${stat.usedPercent}%`
                  : `${fmtBytes(stat.used)} / ${fmtBytes(stat.total)} - ${stat.usedPercent}%`}
              </span>
            </div>
            <div className="resource-meter-bar">
              <div className={`resource-meter-fill ${meterLevel(stat.usedPercent)}`} style={{ width: `${stat.usedPercent}%` }} />
            </div>
          </div>
        ))}
      </div>
      {serverResources.containers.length > 0 && (
        <div className="container-stats-wrapper">
          <table className="container-stats-table">
            <thead>
              <tr>
                <th>Container</th>
                <th>CPU</th>
                <th>Mem</th>
              </tr>
            </thead>
            <tbody>
              {serverResources.containers.map((c) => (
                <tr key={c.name}>
                  <td className="container-name">{c.name}</td>
                  <td className="container-num">{c.cpuPercent.toFixed(2)}%</td>
                  <td className="container-num">{fmtBytes(c.memUsed)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
